import firebase from 'firebase'

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyB5ZHzsoRnlPod5-2SFXBV-_pTNV7E6P6c",
    authDomain: "tinder-clone-8f952.firebaseapp.com",
    databaseURL: "https://tinder-clone-8f952.firebaseio.com",
    projectId: "tinder-clone-8f952",
    storageBucket: "tinder-clone-8f952.appspot.com",
    messagingSenderId: "650259808430",
    appId: "1:650259808430:web:d8f0e7d31be42e367ead3f",
    measurementId: "G-2CR21HGCT1"
  })

const database = firebaseApp.firestore()

export default database